import React from 'react';
import "./FourthSection.css";

const FourthSection = () => {
    return (
        <div>
            
        </div>
    );
};

export default FourthSection;